import React, { useState } from 'react'
import moment from 'moment'
import { Input, Button } from '@Common/Components'
import state from '../../State'

const GRID_NORMAL = [
  `'startStation startStation startStation endStation endStation endStation code code'
    'endDate endDate endDate endHour endHour endHour company company'
  `,
  '\' startDate startHour description description \''
]
const GRID_SMALL = [
  `'startStation startStation startStation startStation endStation endStation endStation endStation  '
  'endDate endDate endDate endDate endHour endHour endHour endHour'
  'code code code code company company company company'
`,
  `'startDate startDate startDate'
'startHour startHour startHour'
'description description description'
`
]

const Train = ({ item = {}, onDelete, index, onUpdate, price }) => {
  const [showOptional, setShowOptional] = useState(false)

  const { _id = '' } = item

  const updateItem = (update) => {
    onUpdate('trainForm', { _id, ...update })
  }

  const { main, grid } = styles
  const config = state.config.state
  const screenWidth = 1500

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {index > 0 && (
        <hr
          style={{
            height: 2,
            width: '100%',
            backgroundColor: 'white',
            border: 'none'
          }}
        />
      )}
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
        <div style={main}>
          <div
            style={{
              display: 'grid',
              width: '100%',
              gridTemplateAreas: screenWidth > config.mediumScreen + 150 ? GRID_NORMAL[1] : GRID_SMALL[1],
              gridGap: '9px'
            }}
          >
            <Input
              date
              id='startDate'
              label='Data Partenza'
              style={{ width: '100%', marginRight: 5, gridArea: 'startDate' }}
              onChange={(e) => updateItem(e)}
              value={item.startDate ? moment(item.startDate).toDate() : ''}
            />
            <Input
              time
              id='startHour'
              label='Ora'
              style={{ width: '100%', marginRight: 5, gridArea: 'startHour' }}
              onChange={(e) =>
                updateItem({
                  startHour: e.startHour !== null ? moment(e.startHour).format('HH:mm') : null
                })}
              value={
                item.startHour
                  ? item.startHour.length > 5
                      ? moment(item.startHour).toDate()
                      : moment(item.startHour, 'HH:mm').toDate()
                  : ''
              }
            />
            {price
              ? (
                <Input
                  keyfilter='Money'
                  label='Descrizione:'
                  id='price'
                  style={{
                    width: '100%',
                    gridArea: 'price',
                    marginLeft: screenWidth > config.mediumScreen + 250 ? 5 : 0
                  }}
                  value={item.price || ''}
                  onChange={(e) => updateItem(e)}
                />
                )
              : null}
            <Input
              id='description'
              label='Descrizione'
              style={{
                width: '100%',
                gridArea: 'description',
                marginLeft: screenWidth > config.mediumScreen + 250 ? 5 : 0
              }}
              onChange={(e) => updateItem(e)}
              value={item.description || ''}
            />
          </div>
          <div
            style={
              showOptional
                ? {
                    ...grid,
                    gridTemplateAreas:
                    screenWidth > config.smallScreen + 450 ? GRID_NORMAL[0] : GRID_SMALL[0]
                  }
                : { display: 'none' }
            }
          >
            <Input
              id='startStation'
              label='Stazione partenza:'
              style={{ gridArea: 'startStation' }}
              onChange={(e) => updateItem(e)}
              value={item.startStation || ''}
            />
            <Input
              id='endStation'
              label='Stazione arrivo:' style={{ gridArea: ' endStation' }}
              onChange={(e) => updateItem(e)}
              value={item.endStation || ''}
            />
            <Input
              date
              id='endDate'
              placeholder='Data arrivo'
              style={{ width: '100%', gridArea: 'endDate' }}
              onChange={(e) => updateItem(e)}
              value={item.endDate ? moment(item.endDate).toDate() : ''}
            />
            <Input
              time
              id='endHour'
              placeholder='Ora arrivo'
              style={{ width: '100%', gridArea: 'endHour' }}
              onChange={(e) => updateItem({ endHour: e.endHour !== null ? moment(e.endHour).format('HH:mm') : null })}
              value={
                item.endHour
                  ? item.endHour.length > 5
                      ? moment(item.endHour).toDate()
                      : moment(item.endHour, 'HH:mm').toDate()
                  : ''
              }
            />

            <Input
              id='code'
              label='Cod Treno'
              style={{ gridArea: 'code' }}
              onChange={(e) => updateItem(e)}
              value={item.code || ''}
            />
            <Input
              id='company'
              label='Compagnia ferroviaria'
              style={{ gridArea: 'company', height: 34 }}
              onChange={(e) => updateItem(e)}
              value={item.company || ''}
            />
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
            marginLeft: 15
          }}
        >
          <Button
            rich
            icon='bin'
            round
            style={{ margin: 3 }}
            width={30}
            onClick={() => onDelete('trainForm', item._id)}
          />
          <Button
            rich
            icon='details'
            round
            style={{ margin: 3 }}
            width={30}
            onClick={() => setShowOptional(!showOptional)}
          />
        </div>
      </div>
    </div>
  )
}

const styles = {
  main: {
    width: '100%',
    height: 'max-content',
    display: 'flex',
    flexDirection: 'column'
  },
  grid: {
    marginTop: 5,
    display: 'grid',
    gridGap: '9px 9px',
    width: '100%',
    height: 'max-content'
  }
}

export default Train
